import React from 'react';

export default function PageLoadError() {
  return (
    <div className="page-not-found-view">
      <div className="wrap padding-y-1 center">
        <div className="jumbo">Uh Oh! This is awkward.</div>
        <div>
          There was an issue loading the page. Please try again. If this issue continues to persist please contact support.
        </div>
      </div>
    </div>
  );
}
